import { SORT_VALUES } from './constants';
export const switchSort = (current) => {
    if (current === SORT_VALUES.ASCEND) {
        return SORT_VALUES.DESCEND;
    }
    return SORT_VALUES.ASCEND;
};
export const getSortedColumnColor = (activeColumn, columnKey) => (activeColumn === columnKey ? 'primary' : 'dove');
export const getSortedColumnIcon = (sortedColumns, columnKey) => sortedColumns[columnKey] === SORT_VALUES.DESCEND
    ? 'square-caret-down'
    : 'square-caret-up';
//# sourceMappingURL=utils.js.map